var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgBusy = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.47715 6.47715 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM15.98 16.53L16.51 16C16.6083 15.904 16.6638 15.7724 16.6638 15.635C16.6638 15.4976 16.6083 15.366 16.51 15.27L12.88 11.64V6.5C12.88 6.22386 12.6561 6 12.38 6H11.62C11.3439 6 11.12 6.22386 11.12 6.5V12.17C11.118 12.3056 11.1723 12.4359 11.27 12.53L15.27 16.53C15.4678 16.7218 15.7822 16.7218 15.98 16.53Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBusy, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Busy.984be080.svg";
export { ForwardRef as ReactComponent };